export default "__VITE_ASSET__88042772__"